import { render, staticRenderFns } from "./DeleteLayoutModal.vue?vue&type=template&id=4a45eff2"
import script from "./DeleteLayoutModal.vue?vue&type=script&lang=js"
export * from "./DeleteLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a45eff2')) {
      api.createRecord('4a45eff2', component.options)
    } else {
      api.reload('4a45eff2', component.options)
    }
    module.hot.accept("./DeleteLayoutModal.vue?vue&type=template&id=4a45eff2", function () {
      api.rerender('4a45eff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/DeleteLayoutModal.vue"
export default component.exports